import { AuthLayout } from '@ifca-root/react-component/src/components/AuthLayout/AuthLayout';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useGetBillAndOutletForNotAuthQuery, useUpdateBuyerDetailsMutation, useUpdateBuyerInformationMutation } from 'generated/graphql';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Logo from 'assets/images/MenuX-Logo.svg';
import Background from 'assets/images/HR-Background.jpg';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { Button, Card, Grid, MenuItem, TextField } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { CommonYupValidation } from 'helpers/yup';
import { SystemMsgs } from 'helpers/SystemMsg';
import * as yup from 'yup';
import { PhoneNumInput } from 'components/Input/PhoneNumInput';
import { AddressAutoCompleteComponent } from '@ifca-root/react-component/src/components/Address/AddressAutoCompleteComponent';
import { useAddressAutoComplete } from 'helpers/hooks/useAddressAutoComplete';
import { countryAlphaCodes } from 'utils/countryAlphaCodes';
import { countryCurrencyCodes } from 'utils/countryCurrencyCodes';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
// import { AuthLayout } from './AuthLayout';

interface BillUserEInvoiceFormProps {
	name: string;
	email: string;
	contactNo: string;
	address: string;
	country: string;
	state: string;
	city: string;
	postcode: string;
	identityNumber: string;
  identityType: string;
	tin: string;
	regNo: string;
}

export const BuyerDetailsForm = (props: any) => {
  const { outletID, orderID } = useParams<any>();
  
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
		SnackBarContext as any,
	);
  
  const {
    loading: billAndOutletForNotAuthLoading,
    data: { getBillAndOutletForNotAuth } = { getBillAndOutletForNotAuth: [] },
  } = useGetBillAndOutletForNotAuthQuery({
    variables: { outletID: outletID },
    fetchPolicy: 'network-only',
    onCompleted: ({ getBillAndOutletForNotAuth }) => {
    },
  });

  const billUserEInvoiceSchema = yup.object().shape({
    name: CommonYupValidation.requireField(SystemMsgs.name()),
    email: yup
      .string()
      .required('Email is required.')
      .trim()
      .test(
        'not-na',
        '"NA" is not allowed.',
        value => value?.toLowerCase() !== 'na',
      )
      .email('Invalid email format.'),
    contactNo: CommonYupValidation.requireField(SystemMsgs.contactNo()),
    regNo: CommonYupValidation.requireField('Registration Number is required'),
    identityNumber: CommonYupValidation.requireField(
      'Identity Number is required',
    ),
    identityType: CommonYupValidation.requireField('Identity Type is required'),
    tin: CommonYupValidation.requireField('TIN is required'),
  });

  const {
    handleSubmit,
    register,
    errors,
    control,
    getValues,
    watch,
    formState: { isSubmitting, isSubmitted, dirtyFields, isDirty },
  } = useForm<BillUserEInvoiceFormProps>({
    defaultValues: {
      address: '',
      country: '',
      state: '',
      city: '',
      postcode: '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(billUserEInvoiceSchema),
  });

  const {
    getCountry,
    getStatebyCountry,
    getCitybyState,
    getPostcodebyCity,
    handleCountryOnChange,
    handleStateOnChange,
    handleCityOnChange,
    handlePostCodeOnChange,
    handleGoogleOnChange,
    query,
    autoCompleteRef,
    state,
    setQuery,
    dispatch,
    initializeEditValue,
  } = useAddressAutoComplete();

  const [country, setCountry] = useState('');
  const [newState, setState] = useState('');
  const [city, setCity] = useState('');
  const [newPostcode, setPostcode] = useState('');
  const [countryCode, setCountryCode] = useState('my');
  const [ogAddr, setOGAddr] = useState(null);
  const [addrValue, setAddress] = useState(null);

  useEffect(() => {
    const regex = new RegExp(`\\b(${country})\\b`, 'g');
    const countryCodes = Object.keys(countryAlphaCodes);
    if (country !== '') {
      countryCodes.forEach(code => {
        if (regex.test(countryAlphaCodes?.[code])) {
          setCountryCode(code.toLowerCase() ?? 'my');
        }
      });
      let alphaCode;
      const currencyCodes = Object.keys(countryCurrencyCodes);
      currencyCodes.forEach(code => {
        if (regex.test(countryCurrencyCodes?.[code])) {
          alphaCode = code;
        }
      });
    }
  }, [country]);

    	const identityTypeData = [
		{
			name: 'Identity Card (NRIC)',
			code: 'NRIC'
		},
		{
			name: 'Passport',
			code: 'PASSPORT'
		},
		{
			name: 'Business Registration Number (BRN)',
			code:'BRN'
		},
		{ name: 'Military Card', 
      code: 'ARMY' 
    },
	];

  const [
    updateBuyerDetails,
    { loading: updateBuyerInformationLoading },
  ] = useUpdateBuyerDetailsMutation({
    onError: error => {
      console.log('ERROR', error);
    },
    onCompleted: data => {
      setOpenSnackBar(true);
      setSnackBarMsg(SystemMsgs.updateRecord());
    },
  });

  console.log('watch() >>>', watch())

  const onSubmit = () => {
    if (updateBuyerInformationLoading) return;
    updateBuyerDetails({
      variables: {
        orderID: orderID,
        buyerInformation: {
          ID: orderID,
          name: watch('name'),
          email: watch('email'),
          contactNo: watch('contactNo')?.replace(/[^+\d]/g, ''),
          identityType: watch('identityType'),
          identityNumber: watch('identityNumber'),
          tin: watch('tin'),
          regNo: watch('regNo'),
          address: {
            address: state?.address,
            country: state?.country?.name,
            state: state?.state?.name,
            city: state?.city?.name,
            postCode: state?.postcode?.postcode,
          },
        },
      }
    });
  }

  return (
    <>
      {/* {billAndOutletForNotAuthLoading && <Loading />} */}
      
      <AuthLayout
				logo={
					getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL ||
					getBillAndOutletForNotAuth[0]?.outlet?.company?.imageUrl
						? null
						: Logo
				}
				image={Background}
				className="margin-override"
			>
        <br></br>

        <CardContents
					style={{
						overflow: 'auto', // Enable vertical scrolling
						// overflowX: 'hidden',
						maxHeight:
							getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL ||
							getBillAndOutletForNotAuth[0]?.outlet?.company?.imageUrl
								? 'calc(115vh - 170px)'
								: 'calc(100vh - 170px)', // Set a max height for the content area
						paddingRight: '10px', // Optional: to prevent horizontal scroll when content is too wide
						willChange: 'transform', // Hint to the browser for scrolling behavior
						marginTop:
							getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL ||
							getBillAndOutletForNotAuth[0]?.outlet?.company?.imageUrl
								? '-40px'
								: '0px',
						marginBottom:
							getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL ||
							getBillAndOutletForNotAuth[0]?.outlet?.company?.imageUrl
								? '-10px'
								: '0px',
					}}
				>
					{getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL ||
					getBillAndOutletForNotAuth[0]?.outlet?.company?.imageUrl ? (
						<Grid container>
							<Grid item xs={12} style={{ textAlign: 'center' }}>
								{getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL ? (
									<img
										className="icon-svg"
										style={{
											width: '200px',
											// marginTop: '20px',
											marginBottom: '10px',
											height: '100px',
										}}
										src={getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL}
										// crossOrigin="anonymous"
									/>
								) : (
									<img
										className="icon-svg"
										style={{
											height: '90px',
											width: '150px',
											// marginTop: '20px',
											marginBottom: '5px',
										}}
										src={getBillAndOutletForNotAuth[0]?.outlet?.logo?.fileURL}
									/>
								)}
							</Grid>
						</Grid>
					) : null}

          <div
            style={{
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '14px',
              fontStyle: 'italic',
              marginTop: '5px',
            }}
          >
            Please complete the following form :
          </div>

          <Controller
            as={TextField}
            name="name"
            fullWidth
            margin="normal"
            label="Name"
            required
            helperText={errors?.name?.message}
            error={errors?.name ? true : false}
            control={control}
            ref={register}
            autoComplete="nope"
          ></Controller>

          <Controller
            as={TextField}
            name="email"
            label="Email Address"
            autoComplete="off"
            multiline={true}
            required
            fullWidth
            ref={register}
            control={control}
            margin="dense"
            helperText={errors?.email?.message}
            error={errors?.email ? true : false}
          ></Controller>

          <Controller
            as={
              <PhoneNumInput
                country={'my'}
                specialLabel="Contact No."
                fullWidth
              />
            }
            name="contactNo"
            type="tel"
            marginTop
            marginBottom
            required
            margin="normal"
            control={control}
            ref={register}
            helperText={errors?.contactNo?.message}
            error={errors?.contactNo ? true : false}
            autoComplete="off"
          ></Controller>

          <AddressAutoCompleteComponent
            getCountry={getCountry}
            getStatebyCountry={getStatebyCountry}
            getCitybyState={getCitybyState}
            getPostcodebyCity={getPostcodebyCity}
            handleCountryOnChange={handleCountryOnChange}
            handleStateOnChange={handleStateOnChange}
            handleCityOnChange={handleCityOnChange}
            handlePostCodeOnChange={handlePostCodeOnChange}
            handleGoogleOnChange={handleGoogleOnChange}
            autoCompleteRef={autoCompleteRef}
            state={state}
            country={country}
            setCountry={setCountry}
            setState={setState}
            setCity={setCity}
            newState={newState}
            newPostcode={newPostcode}
            setPostcode={setPostcode}
            city={city}
            // formType={mode}
            isSubmitted={isSubmitted}
            // editData={editData}
          />

          <Controller
            as={
              <TextField name="identityType">
                {identityTypeData?.map(x => (
                  <MenuItem key={x.name} value={x.code}>
                    {x.name}
                  </MenuItem>
                ))}
              </TextField>
            }
            name="identityType"
            margin="normal"
            label="Identity Type"
            fullWidth
            autoComplete="off"
            multiline={true}
            // defaultValue={data?.einvoice_buyer_identity_type}
            select
            control={control}
            ref={register}
            required
            helperText={errors?.identityType?.message}
            error={errors?.identityType ? true : false}
          />
          
          <Controller
            as={TextField}
            name="identityNumber"
            label="Identity Number"
            autoComplete="off"
            multiline={true}
            required
            fullWidth
            ref={register}
            control={control}
            margin="dense"
            helperText={errors?.identityNumber?.message}
            error={errors?.identityNumber ? true : false}
            inputProps={{
              pattern: '[A-Za-z0-9]*', // Regex to allow only letters and digits
            }}
            onInput={e => {
              // Optional: You can sanitize the input by removing non-alphanumeric characters
              e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
            }}
          ></Controller>

          <Controller
            as={TextField}
            name="tin"
            label="Tax Identification Number (TIN)"
            autoComplete="off"
            multiline={true}
            required
            fullWidth
            ref={register}
            control={control}
            margin="dense"
            helperText={errors?.tin?.message}
            error={errors?.tin ? true : false}
          ></Controller>

          <Controller
            as={TextField}
            name="regNo"
            label="SST Registration Number"
            autoComplete="off"
            multiline={true}
            // required
            fullWidth
            ref={register}
            control={control}
            margin="dense"
            helperText={errors?.regNo?.message}
            error={errors?.regNo ? true : false}
          ></Controller>

				</CardContents>
          <Button
            type="submit"
            variant="contained"
            color={updateBuyerInformationLoading ? 'inherit' : 'primary'}
            className="login-btn"
            disabled={updateBuyerInformationLoading}
            style={
              updateBuyerInformationLoading
                ? {
                    backgroundColor: '#9e9e9e',
                    color: '#ffffff',
                    cursor: 'not-allowed',
                  }
                : undefined
            }
            onClick={() => handleSubmit(onSubmit)()}
          >
            Save
          </Button>
      </AuthLayout>
    </>
  )
}